<template>
  <div>
    <v-tabs class="special-care-tab">
      <v-tab>
        Học sinh cần chăm sóc đặc biệt
        <div class="total-record-box">
          {{this.totalContactModule}}
        </div>
      </v-tab>
<!--      <v-tab>Danh sách học sinh nổi bật-->
<!--        <div class="total-record-box">-->
<!--          0-->
<!--        </div>-->
<!--      </v-tab>-->
      <v-tab-item>
        <SpecialCareStudentTab :filter-form="filterForm" @show-modal-quick-view="showQuickView"></SpecialCareStudentTab>
      </v-tab-item>
<!--      <v-tab-item>-->
<!--        aaa-->
<!--      </v-tab-item>-->
    </v-tabs>
    <modal-quick-view
      v-if="isOpenQuickView"
      :isShow="isOpenQuickView"
      :contact="selectedContact"
      :contactId="selectedContactId"
      :id="selectedItemId"
      :filter-form.sync="filterForm"
      :dataContact="dataContact"
      :routine-student-id="selectedRoutineStudentId"
      :homeroomTeacher="homeroomTeacher"
      :levels="levels"
      :log-filter="logFilter"
      :taskType="1"
      @closeModalQuickView="closeModalQuickView()"
    />
  </div>
</template>

<script>
import { TUTOR_TAB_INDEX } from '@/modules/student_care/constant/constant';
import SpecialCareStudentTab
from '@/modules/student_care/components/special_care/SpecialCareStudentTab.vue';
import ModalQuickView from '@/modules/student_care/components/ModalQuickView.vue';
import { mapState } from 'vuex';
import {
  LEVELS,
} from '../../store/mutation-types';

export default {
  name: 'SpecialCareTable',
  components: { SpecialCareStudentTab, ModalQuickView },
  data() {
    return {
      logFilter: [],
      isOpenQuickView: false,
      selectedContact: null,
      selectedContactId: 0,
      selectedItemId: 0,
      dataContact: {},
      selectedRoutineStudentId: 0,
      homeroomTeacher: {},
      levels: LEVELS,
      TUTOR_TAB_INDEX,
    };
  },
  computed: {
    ...mapState('student_care', ['totalContactModule']),
  },
  props: {
    filterForm: {
      type: Object,
      default: () => {
      },
    },
  },
  methods: {
    closeModalQuickView() {
      this.isOpenQuickView = false;
      this.selectedContactId = 0;
    },
    showQuickView(item, logFilter = []) {
      this.selectedContact = item;
      this.selectedContactId = item.contact_id;
      this.selectedCustomerId = item.lms_core_user_id;
      this.selectedRoutineStudentId = item.id;
      this.homeroomTeacher = { id: item.homeroom_teacher_id, name: item.homeroom_teacher_name };
      this.selectedItemId = item.id;
      this.logFilter = logFilter;
      setTimeout(() => {
        this.isOpenQuickView = true;
      }, 0);
    },
  },
};
</script>

<style>
.total-record-box {
  font-size: 12px;
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  height: 32px;
  width: 55px;
  border-radius: 50%;
  background: #C1BFBF;
}
.special-care-tab .v-tabs-bar{
  background: none !important;
}
.special-care-tab .v-tab {
  box-shadow: 0px 4px 4px 0px #00000040;
  font-size: 12px;
}
.special-care-tab .v-tab.v-tab--active {
  background: white;
  /*box-shadow: 0px 4px 4px 0px #00000040;*/
  color: #F89234;
}
.special-care-tab .v-tab.v-tab--active .total-record-box {
  background: #F89234;
}
.special-care-tab .v-tabs-slider-wrapper {
  top: 0;
  height: 5px !important;
}
.special-care-tab .v-tabs-slider-wrapper .v-tabs-slider {
  border-radius: 4px 4px 0 0;
  background: #F89234;
}
</style>
